import {toDate} from 'date-fns'
import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Time} from 'yougile-util'
import {useBoardFilterUpdateEffect} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {
  CalendarContext,
  CalendarStore,
  Shift,
  useCalendarStore
} from './calendar-store'
import {Slider} from './slider/slider'
import {
  DraggableContext,
  DraggableStore
} from './week/draggable/draggable-store'
import {Week} from './week/week'

export const MainTw = tw.div`
  bg-main-old
  absolute
  left-16
  right-0
  top-[132px]
  h-full
  overflow-hidden
  rounded-tl-[12px]
`

const shifts: Shift[] = ['current']

export const CalendarBase = observer(() => {
  const [state, store] = useCalendarStore()

  useBoardFilterUpdateEffect(() => {
    store.syncState()
  })

  useEffect(() => {
    const interval = setInterval(
      () => store.setTime(toDate(Time.now())),
      Time.minute
    )
    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <MainTw>
      <Slider>
        {shifts.map(shift => (
          <div
            className={cn('h-full', state.cursorGrabbing && 'cursor-grabbing')}
            key={shift}
          >
            <Week shift={shift} />
          </div>
        ))}
      </Slider>
    </MainTw>
  )
})

export const Calendar = () => {
  const [calendarStore] = useState(() => new CalendarStore())
  const [draggableStore] = useState(() => new DraggableStore())

  return (
    <CalendarContext.Provider value={calendarStore}>
      <DraggableContext.Provider value={draggableStore}>
        <CalendarBase />
      </DraggableContext.Provider>
    </CalendarContext.Provider>
  )
}
